import { ProcessType } from "@scts/models";

export const ProcessClose = ({ processType }: { processType: ProcessType | undefined }) => {
  return (
    <>
      {processType === "Appeal" && (
        <span className=" d-none d-sm-block">Close appeal process </span>
      )}
      {processType === "Complaint" && (
        <span className=" d-none d-sm-block">Close complaint process </span>
      )}
      <span className=" d-block d-sm-none">Close process </span>
      <i className="bi bi-chevron-up"></i>
    </>
  );
};

export default ProcessClose;
